import { Injectable } from '@angular/core';
import { FaqAdapter } from './faq.adapter';
import { Observable } from 'rxjs';
import { GgFaq } from '../../model/gg-faq.model';

@Injectable()
export class FaqConnector {
  constructor(protected adapter: FaqAdapter) {}

  get(id: string): Observable<GgFaq> {
    return this.adapter.load(id) as Observable<GgFaq>;
  }
}
